'use client';

import { c as _c } from "react/compiler-runtime";
import { Popover } from '@base-ui/react/popover';
import { type ReactNode } from 'react';
import { NAVIGATION_URLS } from '@libs/core';
import { Backdrop } from '@libs/shared-ui';
import { trackNavigationHeaderClick } from '../../../../../shared';
import { Trigger } from './components';
import { type AccountPopoverVariant, useAccountPopover } from './use-account-popover';
import './account-popover.scss';
type AccountPopoverProps = {
  accountHref: string;
  children: (helpers: {
    close: () => void;
  }) => ReactNode;
  variant: AccountPopoverVariant;
};
export function AccountPopover(t0) {
  const $ = _c(25);
  const {
    accountHref,
    children,
    variant
  } = t0;
  let t1;
  if ($[0] !== variant) {
    t1 = {
      variant
    };
    $[0] = variant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    close,
    isDesktop,
    mobileAnchor,
    portalContainer,
    rootProps,
    setPopoverRoot,
    triggerProps
  } = useAccountPopover(t1);
  let t2;
  if ($[2] !== accountHref) {
    t2 = function handleTriggerClick() {
      if (accountHref === NAVIGATION_URLS.velocity.signIn) {
        trackNavigationHeaderClick({
          selection: "login",
          linkUrl: accountHref
        });
      }
    };
    $[2] = accountHref;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleTriggerClick = t2;
  let t3;
  if ($[4] !== accountHref || $[5] !== handleTriggerClick || $[6] !== triggerProps) {
    t3 = (props, state) => <Trigger accountHref={accountHref} onTriggerClick={handleTriggerClick} props={props} state={state} {...triggerProps} />;
    $[4] = accountHref;
    $[5] = handleTriggerClick;
    $[6] = triggerProps;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isDesktop || $[9] !== t3) {
    t4 = <Popover.Trigger nativeButton={false} openOnHover={isDesktop} delay={100} closeDelay={100} render={t3} />;
    $[8] = isDesktop;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== children || $[12] !== close || $[13] !== isDesktop || $[14] !== mobileAnchor || $[15] !== portalContainer || $[16] !== variant) {
    t5 = portalContainer && <Popover.Portal container={portalContainer}><Popover.Backdrop render={<Backdrop className="account-popover__backdrop" />} /><Popover.Positioner anchor={isDesktop ? undefined : mobileAnchor} side="bottom" align="center" sideOffset={isDesktop ? 16 : 0} collisionPadding={isDesktop ? 16 : 0} collisionAvoidance={{
        fallbackAxisSide: "none",
        side: "none"
      }} positionMethod="absolute" className="account-popover__positioner"><Popover.Popup className="account-popover__popup" data-render-mode={variant}>{children({
            close
          })}</Popover.Popup></Popover.Positioner></Popover.Portal>;
    $[11] = children;
    $[12] = close;
    $[13] = isDesktop;
    $[14] = mobileAnchor;
    $[15] = portalContainer;
    $[16] = variant;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== rootProps || $[19] !== t4 || $[20] !== t5) {
    t6 = <Popover.Root {...rootProps}>{t4}{t5}</Popover.Root>;
    $[18] = rootProps;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== setPopoverRoot || $[23] !== t6) {
    t7 = <div ref={setPopoverRoot} className="account-popover">{t6}</div>;
    $[22] = setPopoverRoot;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}